<template>
  <v-app>
    <router-view />
    <AppFooter />
  </v-app>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'App',
  components: { AppFooter }
}
</script>

